import React from 'react';
import { Modal } from 'antd';

export default function ConfirmationModal({
  show,
  title,
  description,
  confirmationButtonText,
  cancelButtonText,
  onConfirm,
  onCancel,
  confirming,
  cancelling,
}) {
  return (
    show && (
      <Modal
        open
        zIndex={99999}
        title={title}
        onCancel={() => onCancel()}
        okText={confirmationButtonText}
        okButtonProps={{ onClick: onConfirm, loading: confirming }}
        cancelText={cancelButtonText}
        cancelButtonProps={{ onClick: onCancel, loading: cancelling }}
      >
        {description ? <p>{description}</p> : null}
      </Modal>
    )
  );
}
